import { createAuth0Client } from "@auth0/auth0-spa-js";
import { AnyAction, Middleware } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { auth0Provider } from "@/common/auth0Provider";
import { ROUTE_PARTS } from "@/common/constants/routing";
import { authService } from "@/common/services/auth";
import { queryStringParamsService } from "@/common/services/queryStringParams";
import { tenantService } from "@/common/services/tenant";
import { auth0Config } from "@/config/config";

import { appInitialized, prerenderConfigurationsStarted } from "../appCommon/slice";

export const authMiddleware: Middleware<any, any, ThunkDispatch<any, any, AnyAction>> = ({
  dispatch,
  getState,
}) => {
  return (next) => {
    return async (action) => {
      // don't block execution flow with awaits
      (async () => {
        if (prerenderConfigurationsStarted.match(action)) {
          let connection = auth0Config.defaultConnection;

          const redirectUrl =
            tenantService.strategy === "basepath"
              ? `${window.location.origin}/${tenantService.defaultTenantIdentifier}/${ROUTE_PARTS.AUTH0_CALLBACK}`
              : `${window.location.origin}/${ROUTE_PARTS.AUTH0_CALLBACK}`;

          const authParams = queryStringParamsService.getCurrentAuthParams();
          if (
            authParams?.preferredAuth0Connection &&
            Object.values(auth0Config.connections).includes(authParams.preferredAuth0Connection)
          ) {
            console.log("Auth params detected in query string:", authParams);
            connection = authParams.preferredAuth0Connection;
          }

          try {
            const auth0Client = await createAuth0Client({
              domain: auth0Config.domain,
              clientId: auth0Config.client_id,
              authorizationParams: {
                redirect_uri: redirectUrl,
                audience: auth0Config.audience,
                connection: connection,
                scope: "openid profile email offline_access",
              },
              httpTimeoutInSeconds: 10,
              sessionCheckExpiryDays: auth0Config.sessionCheckExpiryDays,
              useRefreshTokens: true,
              useRefreshTokensFallback: true,
              cacheLocation: "localstorage",
            });
            auth0Provider.setAuth0Client(auth0Client);
          } catch (err) {
            console.error("Create Auth0 client error: ", err);
          }

          await authService.checkAuthenticatedStatus();
        } else if (appInitialized.match(action)) {
          await authService.checkAuthenticatedStatus();
        }
      })();

      return next(action);
    };
  };
};
